import { _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import "./ObjectDinamicViewer.css";

export const ObjectDinamicViewer = ({ data, head, columns=null }) => {

    const renderRows = () => {
        const rows = [];
        
        if (head && head.length > 0) {
            head.forEach(({ property, title, visible, mask }) => {
                if (visible && data.hasOwnProperty(property)) {
                    rows.push(
                        <>
                            {/* <td className="tittle_propertie">{title || property}:</td>
                            <td className="text-end">{renderValue(data[property], mask)}</td> */}
                            <td>
                                <small className="tittle_propertie">{title || property}</small><br />
                                <p className="value_propertie">{renderValue(data[property], mask)}</p>
                            </td>
                        </>
                    );
                }
            });
        } else {
            Object.entries(data).forEach(([key, value]) => {
                rows.push(
                    <>
                        <td className="tittle_propertie">{key}:</td>
                        <td className="text-end">{`${value}`}</td>
                    </>
                );
            });
        }

        return rows;
    };

    const renderValue = (value, mask) => {
        return <span dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(value, mask) }} />;
    };

    const splitIntoColumns = (rows, columns) => {
        if (!columns) {
            return rows.map((row, index) => (
                <tr key={index}>{row}</tr>
            ));
        }

        const totalRows = Math.ceil(rows.length / columns);
        const tableRows = [];

        for (let i = 0; i < totalRows; i++) {
            const cells = [];
            for (let j = 0; j < columns; j++) {
                const index = i + j * totalRows;
                if (rows[index]) {
                    cells.push(rows[index]);
                } else {
                    cells.push(<><td></td><td></td></>);
                }
            }
            tableRows.push(<tr key={i}>{cells}</tr>);
        }

        return tableRows;
    };

    const rows = renderRows();
    const tableRows = splitIntoColumns(rows, columns);

    return (
        <table className="table table-striped table_form mt-2">
            <tbody>{tableRows}</tbody>
        </table>
    );
};
